import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { takeUntil } from "rxjs/operators";
import { AccVoucherHeader } from "../models/accvoucherheader.model";
import { VoucherInfo } from "../models/voucherInfo.model";

@Component({
  selector: "ngx-voucher-approve",
  templateUrl: "./voucher-approve.component.html",
  styleUrls: ["./voucher-approve.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoucherApproveComponent extends BaseFormComponent<AccVoucherHeader> {
  erroremessage: string;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.label = "قطعی کردن اسناد";
    this.apiName = "AccVoucherHeader/VoucherApprove";
    super.ngOnInit();
    this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
  }
  setColumnAttribute() {
    this.orignalColumns = this.orignalColumns.filter((x) => x.name === "VoucherDate");
    this.columns = this.orignalColumns;
  }
  setdefault() {
    if (!this.model.VoucherDate) this.model.VoucherDate = new Date();
    if (
      new Date(this.model.VoucherDate).setHours(0, 0, 0, 0) > new Date(this.accountService.authService.currentFiscalYear.EndDate).setHours(0, 0, 0, 0)
    )
      this.model.VoucherDate = this.accountService.authService.currentFiscalYear.EndDate;
  }
  isValid() {
    let flag: boolean = true;
    if (!this.formGroup.controls["VoucherDate"].value) {
      flag = false;
      this.erroremessage = "تاریخ انتخاب نشده است.";
    }
    return flag;
  }
  async save() {
    if (!this.isSaving && this.isValid()) {
      this.isSaving = true;
      this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
      if (this.model.FiscalYearId && this.model.FiscalYearId > 0)
        this.sts.showDialog(`آیا از قطعی کردن اسناد اطمینان دارید؟`, "قطعی کردن اسناد", DialogType.confirm, () => this.VoucherApprove());
      else
        this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
          if (x) {
            this.model.FiscalYearId = x.Id;
            this.sts.showDialog(`آیا از قطعی کردن اسناد اطمینان دارید؟`, "قطعی کردن اسناد", DialogType.confirm, () => this.VoucherApprove());
          }
        });
    }
  }
  VoucherApprove() {
    let entity: VoucherInfo = <VoucherInfo>{};
    entity.VoucherDate = this.formGroup.controls["VoucherDate"].value;
    entity.BranchId = this.accountService.authService.currentBranchId;
    entity.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    this.httpCommonService
      .create(this.apiName, entity)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (row) => this.saveSuccessHelper(row),
        (error) => this.saveFailedHelper(error)
      );
  }
}
